module.exports = __webpack_public_path__ + "img/VetoSans-MediumItalic_1.7c6d8156.svg";